module.exports = __webpack_public_path__ + "img/d82f323eb24c5efc38f1ce557bfa6923.png";